module.exports = __webpack_public_path__ + "img/y-axis.d34839f2.svg";